import { Component, OnInit, Input } from '@angular/core';
import { BaseAsset } from '../../models/assets/BaseAsset';
import { AssetTypeService } from 'src/app/services/asset-type.service';
import { AssetManagementService } from '../../services/asset-management.service';
import { ModalController, NavParams } from '@ionic/angular';
import { MediaAsset } from 'src/app/models/assets/MediaAsset';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { reverse } from 'dns';
import { UnfocusElementService } from 'src/app/services/unfocus-element.service';
import { FileSizeService } from 'src/app/services/file-size.service';


@Component({
  selector: 'app-view-asset-storage-modal',
  templateUrl: './view-asset-storage-modal.page.html',
  styleUrls: ['./view-asset-storage-modal.page.scss'],
})
export class ViewAssetStorageModalPage implements OnInit {
  public assets: any[];

  public paginatedAssets = [];
  p: number = 1;

  //Sorting Options
  public key: string = 'name'; // Default field
  public reverse: boolean = false;  // Default Sort (false = Ascending)
  public caretDownIcon = 'arrow-dropdown';
  public caretUpIcon = 'arrow-dropup';

  constructor(navParams: NavParams,
    public assetManagementService: AssetManagementService,
    public assetTypeService: AssetTypeService,
    public modalController: ModalController,
    public unfocusService: UnfocusElementService,
    public fileSizeService: FileSizeService
  ) {
  }

  ngOnInit() {
    this.assets = this.assetManagementService.assetsCopy.slice();
    this.assets.forEach((asset, index) => {
      asset.size = this.fileSizeService.getFileSizeWithMetric(asset);
    });
  }

  cancelModal() {
    this.modalController.dismiss();
  }

  async deleteAsset(event, asset) {
    this.unfocusService.unfocus(event);
    this.assetManagementService.deleteAsset(asset).then(x => {
      this.assets = this.assetManagementService.assetsCopy;
    });
  }

  getAssetType(id) {
    return this.assetTypeService.getType(id);
  }

  sortBy(key: string) {
    if (this.key != key) {
      this.key = key;
      this.reverse = false;
    } else {
      this.reverse = !this.reverse;
    }
  }
}
